export const STAGES_START = 'STAGES_START';
export const STAGES_SUCCESS = 'STAGES_SUCCESS';
export const STAGES_FAILURE = 'STAGES_FAILURE';
export const STAGES_RESET = 'STAGES_RESET';
export const GET_STAGE_WITH_TRACK_ID = 'GET_STAGE_WITH_TRACK_ID';
